export default __webpack_public_path__ + "media/images/portfolio/gallery-04-370x470-3d0e18c992fbfd2e2bc72ada62ac7141.jpg";